module.exports = __webpack_public_path__ + "img/hoodie.c26edb94.png";